<div class="flex flex-col h-screen bg-white overflow-hidden">
    <!-- Header -->
    <header class="flex-none p-6 z-20 bg-white relative">
        <a routerLink="/login" class="inline-block">
            <img src="assets/FINTRAX_LOGO_POS.svg" alt="Fintrax" class="h-10" />
        </a>
    </header>

    <!-- Main Content -->
    <main class="flex-grow flex items-center justify-center p-6 bg-slate-50/50 overflow-y-auto">
        <div class="w-full max-w-lg bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col my-auto">
            
            <h1 class="text-2xl font-bold text-slate-800 mb-8 text-center" i18n="@@register.title">Registreren</h1>

            <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" class="flex flex-col w-full gap-5">
                
                <!-- Email -->
                <div class="flex flex-col gap-2">
                    <label for="inputEmail" class="text-sm font-medium text-slate-700" i18n="@@register.email">E-mailadres*</label>
                    <input 
                        id="inputEmail" 
                        type="email" 
                        formControlName="email" 
                        class="w-full px-4 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition-all" 
                        required 
                    />
                    @if (registrationForm.controls.email.touched && registrationForm.controls.email.errors?.email) {
                        <div class="text-sm text-red-600" i18n="@@error.email">Dit is geen geldig e-mailadres.</div>
                    }
                    @if (registrationForm.controls.email.touched && registrationForm.controls.email.errors?.required) {
                        <div class="text-sm text-red-600" i18n="@@error.required">Dit veld is verplicht.</div>
                    }
                    @if (registrationForm.controls.email.touched && registrationForm.controls.email.errors?.backend) {
                        <div class="text-sm text-red-600">{{ registrationForm.controls.email.errors?.backend }}</div>
                    }
                </div>

                <!-- First Name -->
                <div class="flex flex-col gap-2">
                    <label for="inputFirstName" class="text-sm font-medium text-slate-700" i18n="@@register.firstname">Voornaam*</label>
                    <input 
                        id="inputFirstName" 
                        type="text" 
                        formControlName="firstName" 
                        class="w-full px-4 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition-all" 
                    />
                    @if (registrationForm.controls.firstName.touched && registrationForm.controls.firstName.errors?.required) {
                        <div class="text-sm text-red-600" i18n="@@error.required">Dit veld is verplicht.</div>
                    }
                </div>

                <!-- Last Name -->
                <div class="flex flex-col gap-2">
                    <label for="inputLastName" class="text-sm font-medium text-slate-700" i18n="@@register.lastName">Familienaam*</label>
                    <input 
                        id="inputLastName" 
                        type="text" 
                        formControlName="lastName" 
                        class="w-full px-4 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition-all" 
                    />
                    @if (registrationForm.controls.lastName.touched && registrationForm.controls.lastName.errors?.required) {
                        <div class="text-sm text-red-600" i18n="@@error.required">Dit veld is verplicht.</div>
                    }
                </div>

                <!-- Password -->
                <div class="flex flex-col gap-2">
                    <label for="inputPassword1" class="text-sm font-medium text-slate-700" i18n="@@register.password">Wachtwoord*</label>
                    <app-password-toggle>
                        <input 
                            id="inputPassword1" 
                            type="password" 
                            formControlName="password1" 
                            class="w-full px-4 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition-all" 
                            required 
                        />
                    </app-password-toggle>
                    @if (registrationForm.controls.password1.touched && registrationForm.controls.password1.errors?.required) {
                        <div class="text-sm text-red-600" i18n="@@error.required">Dit veld is verplicht.</div>
                    }
                    @if (registrationForm.controls.password1.touched && registrationForm.controls.password1.errors?.minlength) {
                        <div class="text-sm text-red-600" i18n="@@register.error.minlength">Het wachtwoord moet minstens {{ minPasswordLength }} tekens lang zijn</div>
                    }
                    @if (registrationForm.controls.password1.touched && registrationForm.controls.password1.errors?.passwordStrength?.hasUpperCase === false) {
                        <div class="text-sm text-red-600" i18n="@@register.error.hasUpperCase">Het wachtwoord moet hoofdletters bevatten</div>
                    }
                    @if (registrationForm.controls.password1.touched && registrationForm.controls.password1.errors?.passwordStrength?.hasLowerCase === false) {
                        <div class="text-sm text-red-600" i18n="@@register.error.hasLowerCase">Het wachtwoord moet kleine letters bevatten</div>
                    }
                    @if (registrationForm.controls.password1.touched && registrationForm.controls.password1.errors?.passwordStrength?.hasNumeric === false) {
                        <div class="text-sm text-red-600" i18n="@@register.error.hasNumeric">Het wachtwoord moet cijfers bevatten</div>
                    }
                    @if (registrationForm.controls.password1.touched && registrationForm.controls.password1.errors?.passwordStrength?.hasSpecial === false) {
                        <div class="text-sm text-red-600" i18n="@@register.error.hasSpecial">Het wachtwoord moet bijzondere tekens bevatten ({{ specialCharacters | join: ', ' }})</div>
                    }
                </div>

                <!-- Confirm Password -->
                <div class="flex flex-col gap-2">
                    <label for="inputPassword2" class="text-sm font-medium text-slate-700" i18n="@@form.passwordVerification">Wachtwoord opnieuw invoeren*</label>
                    <app-password-toggle>
                        <input 
                            id="inputPassword2" 
                            type="password" 
                            formControlName="password2" 
                            class="w-full px-4 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition-all" 
                            required 
                        />
                    </app-password-toggle>
                    @if (registrationForm.controls.password2.touched && registrationForm.errors?.notEqual) {
                        <div class="text-sm text-red-600" i18n="@@register.error.passwordVerification">Wachtwoorden komen niet overeen.</div>
                    }
                    @if (registrationForm.controls.password2.touched && registrationForm.controls.password2.errors?.required) {
                        <div class="text-sm text-red-600" i18n="@@error.required">Dit veld is verplicht.</div>
                    }
                </div>

                <!-- Submit Button -->
                <button 
                    type="submit" 
                    class="button-primary w-full py-3 mt-4 rounded-lg font-medium shadow-sm hover:shadow-md transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    [disabled]="busy"
                >
                    @if (!busy) {
                        <span i18n="@@register">Registreer</span>
                    } @else {
                        <fa-icon [icon]="loadingIcon" [animation]="'spin'"></fa-icon>
                        <span i18n="@@register.loading">Bezig met registreren…</span>
                    }
                </button>

                 <!-- Separator -->
                 <div class="relative flex items-center py-4">
                    <div class="flex-grow border-t border-slate-200"></div>
                    <span class="mx-4 text-xs font-semibold text-slate-400 uppercase tracking-wider" i18n="@@choice.or">of</span>
                    <div class="flex-grow border-t border-slate-200"></div>
                </div>

                <!-- Silverfin Login Button -->
                <a
                    type="button"
                    class="button-silverfin w-full flex items-center justify-center gap-3 py-3 rounded-lg transition-all hover:opacity-90 active:scale-[0.98] hover:no-underline"
                    [href]="silverfinLogin"
                >
                    <img class="h-8 w-auto" src="/assets/icons/silverfin.png" />
                    <span class="font-medium text-white" i18n="@@login.loginSilverfin">Meld aan met Silverfin</span>
                </a>

                <!-- Links -->
                <div class="mt-4 flex flex-col items-center gap-3 text-sm">
                    <a routerLink="/login" class="font-bold text-blue-600 hover:text-blue-700 hover:underline" i18n="@@login.link">Log in</a>
                    <div class="flex gap-4 text-slate-500">
                        <a routerLink="/reset-password" class="hover:text-slate-800 hover:underline" i18n="@@login.forgotPassword">Wachtwoord vergeten</a>
                        <span>•</span>
                        <a href="#" class="hover:text-slate-800 hover:underline" i18n="@@verificationMail.linkAgain">Stuur verificatiemail opnieuw</a>
                    </div>
                </div>

            </form>
        </div>
    </main>
</div>
